import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import avatar from '../assets/images/senayakkis.png';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/yujisatojr" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/senayakkis/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Şenay Akkis</h1>
          <p>Industrial Engineer & Data Scientist</p>
          <p className="affiliations">
            Founder, <a href="https://odoino.com/" target="_blank" rel="noreferrer">Odoino</a> · Co-Founder,{' '}
            <a href="https://akkivo.ai/en" target="_blank" rel="noreferrer">AKKIVO</a>
          </p>
          <p className="summary">
            Şenay Akkis is an Industrial Engineer and Data Scientist who founded Odoino and
            co-founded AKKIVO.
          </p>

          <div className="mobile_social_icons">
            <a href="https://github.com/yujisatojr" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/senayakkis/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;